export const whiteBoxNotificationSettings = state =>
  state.mainShellReducer.whiteBoxNotification;

export const isWhiteBoxNotificationOpen = state =>
  state.mainShellReducer.whiteBoxNotification.isOpen;
